import React, { useState, useEffect } from "react";
import axios from "axios";
import { Avatar, Table, Input, DatePicker, Modal, Button, Menu, Col, Row, message, Space, Checkbox, Carousel } from "antd";
import { Link, useParams, useNavigate } from "react-router-dom";
import { InboxOutlined, PlusOutlined, UserOutlined, ExclamationCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import NewTable from "./components/NewTable";
import './css/TableTitle.css';
const PositionList = () => {
    const [total, set_total] = useState(1);
    const [extra_columns, set_extra_columns] = useState(null);
    const [search_date, set_search_date] = useState([undefined, undefined])
    const [loading, set_loading] = useState(0)
    const [force_reload, set_force_reload] = useState(0)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);

    return (<>
        {/* <NewTable
            total={total}
            extra_columns={extra_columns}
            set_extra_columns={set_extra_columns}
            loading={loading}
            page_name={'PositionList'}
            force_reload={force_reload}
            // columns={default_column.concat(extra_columns || [])}
            // getData={getData}
            // datas={datas}
            add_button_title={'新增職位'}//新增按鈕上的名稱
            // handleOnAddRow={handleOnAddRow}//新增row 內容
            // rowkey={'administration_id'}//key
            setSelectedRowKeys={setSelectedRowKeys}
            selectedRowKeys={selectedRowKeys}
            // handleOnDeleteRow={handleOnDeleteRow}//多筆刪除
            searchdate={false}
        ></NewTable> */}
    </>)
}
export default PositionList;